//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  root: {
    flexGrow: 1,
    marginBottom: 20,
    padding: theme.spacing(2),
  },
  tableDownInResponsive: {
    marginBottom: 150,
    marginTop: theme.spacing(3),
  },
  createBtn: {
    float: "right",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  historyBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    cursor: "pointer",
    padding: "4px 8px",
    minWidth: "60px",
    textAlign: "center",
    whiteSpace: "nowrap",
    display: "inline-block",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },

  wordBreakCell: {
    overflowWrap: "break-word", 
    wordBreak: "break-word",   
    whiteSpace: "normal",       
  },  
  templateCell: {
    whiteSpace: "nowrap",        // Don't allow line break
    overflow: "visible",         // Allow content to fully show
    textOverflow: "unset",       // No ellipsis
    paddingRight: 4,             // Adjust spacing between columns
    fontSize: 14,
  },
  
  descriptionCell: {
    whiteSpace: "normal",        // Allow description to wrap
    paddingLeft: 4,              // Match padding
    fontSize: 14,
  },
  
  

}));
